import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=191769ae&scoped=true&"
import script from "./Commission.vue?vue&type=script&lang=js&"
export * from "./Commission.vue?vue&type=script&lang=js&"
import style0 from "./Commission.vue?vue&type=style&index=0&id=191769ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191769ae",
  null
  
)

export default component.exports